import { useEffect } from 'react';
import { useAppContext } from '../../hooks/useAppContext';
import loadScript from '../../services/loadScript';

export default function BookConsultation() {
    const { user } = useAppContext();

    useEffect(() => {
        loadScript('https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js');
    }, []);

    const params = new URLSearchParams({
        embed: 'true',
        email: user.email,
        lastname: user.lastName ?? '',
        firstname: user.firstName,
    });

    return (
        <div
            className="meetings-iframe-container"
            data-src={`https://meetings.hubspot.com/si-lsanders/15-min-discovery?${params}`}
        />
    );
}
